import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import ButtonSelectGroup from "../../shared/ButtonSelectGroup"
import useButtonSingleSelect from "../../hooks/useButtonSingleSelect"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"

const ViewName = Steps.PRESERVATION

export default function PreservationStep(): JSX.Element {
  const { routingData, updateRoutingInfo } = useRoutingInfo()
  const defaultValue = routingData?.preservationInterest
  const { setNextStep } = useStateMachine(ViewName, defaultValue ? "" : null)
  const { handleContinueLoading, continueLoading } = useJourneyFlow()
  const { valid, ...buttonProps } = useButtonSingleSelect({
    options: [
      { title: "Preserving sperm", id: "PRESERVE_SPERM" },
      { title: "Preserving eggs", id: "PRESERVE_EGGS" }
    ],
    defaultValue,
    onSubmit: onClickContinue
  })
  async function onClickContinue(selectedValue: string): Promise<void> {
    if (selectedValue !== null) {
      await handleContinueLoading(() => updateRoutingInfo({ preservationInterest: selectedValue }))
      setNextStep(ViewName, "")
    }
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue(defaultValue)
      }}
    >
      <Container>
        <H2 stack="large">What kind of preservation are you interested in?</H2>
        <ButtonSelectGroup {...buttonProps} />
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="flex-end">
        <ArrowSubmitButton enabled={valid && !continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
